import blackChecker from '@ui-kit/images/checker_black.png';
import whiteChecker from '@ui-kit/images/checker_white.png';
import { t } from '@base/utils/helpers';
import styles from '../styles/createTablePickColor.module.scss';
import classNames from 'classnames';

export const CreateTablePickColor = (props: {
  gameColor: number;
  handlerPickColor: (value: number) => void;
}) => {
  const { gameColor, handlerPickColor } = props;

  return (
    <div className={styles.pickColor}>
      <div className={styles.wrap} onClick={() => handlerPickColor(1)}>
        <span className={styles.text}>{`${t('play')} ${t('black')}`}</span>
        <img
          className={classNames(styles.image, { [styles.active]: gameColor === 1 })}
          src={blackChecker}
          alt="play black color"
        />
      </div>
      <div className={styles.wrap} onClick={() => handlerPickColor(0)}>
        <img
          className={classNames(styles.image, { [styles.active]: gameColor === 0 })}
          src={whiteChecker}
          alt="play white color"
        />
        <span className={styles.text}>{`${t('play')} ${t('white')}`}</span>
      </div>
    </div>
  );
};
